import axios from '../utils/axios';

export default function changeSeekerActivationStatus(adminId, data){
    return axios.post(`/admin/${adminId}/jobseeker-admin/user/admin/change-activation-status`, data);
}